import { getRndId } from "@/utils/randomIdGenerator";

export class Alert {
  public id: string;
  public type: AlertType = AlertType.INFO;
  public message: string = "";
  public autodismissable: boolean = true;

  constructor(type?: AlertType, message?: string, autodismissable = true) {
    this.id = getRndId();
    this.type = type || this.type;
    this.message = message || this.message;
    this.autodismissable = autodismissable;
  }
}

export enum AlertType {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  SUCCESS = "success",
}
